import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { shimTextEncoding } from 'utils/shimTextEncoding';

import i18n from './i18n';
import { CloudKeyUnlockApp } from './CloudKeyUnlockApp';

import '../app/assets/scss/main.scss';

const initializationPromises = [];

if (!window.TextDecoder) {
  initializationPromises.push(shimTextEncoding());
}

Promise.allSettled(initializationPromises).then(() => {
  const rootElement = document.getElementById('root');

  if (!rootElement) throw new Error('Failed to find the root element');

  const root = createRoot(rootElement);

  root.render(
    <I18nextProvider defaultNS="translation" i18n={i18n}>
      <CloudKeyUnlockApp />
    </I18nextProvider>,
  );
});
